import { Component, Input, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";

import { DonutChartInfo } from '../../dashboard';
import { colorutils } from '../../../../common/colorutils';

import { BaseDashboardWidgetComponent } from '../../../../common/bases/base.dashboard-widget.component';

import { TranslationService } from '../../../../services/translation.service';
import { DashboardService } from '../../../../services/dashboard.service';


@Component({
  selector: "app-dashboard-sleeping-equipments",
  templateUrl: './dashboard-sleeping-equipments.component.html',
})
export class DashboardSleepingEquipmentsComponent extends BaseDashboardWidgetComponent {

  constructor(
    protected router: Router,
    protected translationService: TranslationService,
    protected dashboard_service: DashboardService) {
    super(translationService);
  }

  ngOnInit() {
  }

  protected onGetChartName(): string {
    return "chart_location_sleeping";
  }

  protected async onGetData(args: any) {
    return await this.dashboard_service.getLocationSleepingEquipments(args).toPromise();
  }

  protected onGetChartOptions(data: any): any {
    // Chart for location (departments) of sleeping equipments
    let chart = new DonutChartInfo(this.translationService.translate('Location of sleeping equipments'));
    for (var i = 0; i < data.length; i++)
      chart.addSerie(data[i].name, data[i].total, colorutils.getColor(i), data[i].id, (id) => { this.onClick(id); });
    return chart.getOptions();
  }
}